import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import Intro from "./Intro";
import { CenterMahi } from "./subComponents/AllSvgs";
import LogoComponent from "./subComponents/LogoComponent";
import PowerButton from "./subComponents/PowerButton";
import SocialIcons from "./subComponents/SocialIcons";
import { motion } from "framer-motion";
import ParticleBackground from "./subComponents/ParticlesBackground";
import Resume from "../assets/Images/resume_button.png";
import ResumeFile from "../assets/Images/Mahesh_Gaikwad_Resume.pdf";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const MainContainer = styled.div`
  background: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Karla", sans-serif;
    font-weight: 500;
  }
`;

const Container = styled.div`
  padding: 2rem;
`;

const Contact = styled(NavLink)`
  color: ${(props) => props.theme.text};
  position: absolute;
  top: 2rem;
  right: calc(1rem + 2vw);
  text-decoration: none;
  z-index: 1;
`;

const ResumeBtn = styled(NavLink)`
  color: ${(props) => props.theme.text};
  position: absolute;
  top: 2rem;
  right: calc(7rem + 2vw);
  text-decoration: none;
  z-index: 1;
  @media (max-width: 768px) {
    right: 1rem;
    top: 80%;
  }
`;
const BLOG = styled(NavLink)`
  color: ${(props) => props.theme.text};
  position: absolute;
  top: 54%;
  right: calc(0.5rem + 0vw);
  transform: rotate(90deg) translate(-50%, -50%);
  text-decoration: none;
  z-index: 1;
`;

const WORK = styled(NavLink)`
  color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
  position: absolute;
  top: 50%;
  left: calc(1rem + 2vw);
  transform: translate(-50%, -50%) rotate(-90deg);
  text-decoration: none;
  z-index: 1;
`;

const BottomBar = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 0;
  right: 0;
  width: 100%;

  display: flex;
  justify-content: space-evenly;

  @media (max-width: 620px) {
    bottom: 0.5rem;
  }
`;

const ABOUT = styled(NavLink)`
  color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
  text-decoration: none;
  z-index: 1;
`;
const SKILLS = styled(NavLink)`
  color: ${(props) => props.theme.text};
  text-decoration: none;
  z-index: 1;
`;

const rotate = keyframes`

  from{
    transform: rotate(0);
  }
  to{
    transform: rotate(360deg);
  }
`;

const Center = styled.button`
position: absolute;
top: ${(props) => (props.click ? "92%" : "50%")};
left:${(props) => (props.click ? "95%" : "50%")};
transform: translate(-50%,-50%);
border: none;
outline: none;
background-color: transparent;
cursor:pointer;
width:

display:flex;
flex-direction: column;
justify-content: center;
align-items: center;
transition: all 1s ease; 

&>:first-child{
  // animation:${rotate} infinite 1.5s linear;
}
&>:last-child{
  display:${(props) => (props.click ? "none" : "inline-block")}
  padding-top: 1rem;
}
@media (max-width: 620px) {
  top: ${(props) => (props.click ? "17%" : "50%")};
  left:${(props) => (props.click ? "80%" : "50%")};
`;
const DarkDiv = styled.div`
  position: absolute;
  top: 0;
  background-color: #000;
  bottom: 0;
  right: 50%;
  width: ${(props) => (props.click ? "50%" : "0%")};
  height: ${(props) => (props.click ? "100%" : "0%")};
  z-index: 1;
  transition: height 0.5s ease, width 1s ease 0.5s;
`;

const Main = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <MainContainer>
      <ParticleBackground />
      <DarkDiv click={click} />
      <Container>
        <PowerButton />
        <LogoComponent theme={click ? "dark" : "light"} />
        <SocialIcons theme={click ? "dark" : "light"} />
        <Tippy content="Click Me"  interactiveBorder={20} delay={100}>
          <Center click={click}>
            <CenterMahi
              onClick={() => handleClick()}
              width={click ? 150 : 300}
              height={click ? 150 : 300}
              fill="currentColor"
            />
            {/* <span>click here</span> */}
          </Center>
        </Tippy>
        <Tippy content="Mail to Connect">
          <Contact
            target="_blank"
            as="a"
            href="mailto:gaikwadmahesh777g@gmail.com?subject=About Hiring&body=I have visited your profile and found it fit for the role in our company"
          >
            <motion.h2
              initial={{
                y: -200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              Say hi..
            </motion.h2>
          </Contact>
        </Tippy>

        <Tippy content="Download Resume">
          <ResumeBtn
            target="_blank"
            as="a"
            href={'https://docs.google.com/document/d/18cw6Kk3h5Hr5K8jzKVijtUDKglK2_rkrbP96HehLEyQ/edit?usp=sharing'}
            download="Mahesh Gaikwad Resume"
          >
            <motion.h2
              initial={{
                y: -200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <img  style={{ width: "2rem" }} src={Resume} alt="resume_btn" />
            </motion.h2>
          </ResumeBtn>
        </Tippy>

        <BLOG to="/activities">
          <motion.h2
            initial={{
              y: -200,
              transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            animate={{
              y: 0,
              transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Activities
          </motion.h2>
        </BLOG>

        <WORK to="/work" click={click}>
          <motion.h2
            initial={{
              y: -200,
              transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            animate={{
              y: 0,
              transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Works
          </motion.h2>
        </WORK>

        <BottomBar>
          <ABOUT to="/about" click={click}>
            <motion.h2
              initial={{
                y: 200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              About
            </motion.h2>
          </ABOUT>
          <SKILLS to="/skill">
            <motion.h2
              initial={{
                y: 200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              My Skills
            </motion.h2>
          </SKILLS>
        </BottomBar>
      </Container>
      {click ? <Intro /> : null}
    </MainContainer>
  );
};

export default Main;
